// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__8j7X4","header":"PatientBlock_header__3_vfe","label":"PatientBlock_label__1oegQ","option":"PatientBlock_option__2JQj6"};